import { formatDecimal, getDisplayDecimals } from './format-decimal';

export const isUsdtLikeAsset = (assetLabel: string | null | undefined): boolean => {
  if (assetLabel == null || assetLabel.trim() === '') {
    return true;
  }

  return assetLabel.trim().toUpperCase() === 'USDT';
};

export const formatLedgerAmount = (
  value: string | number | null | undefined,
  options?: {
    assetLabel?: string | null;
    signed?: boolean;
    emptyLabel?: string;
  },
): string => {
  const emptyLabel = options?.emptyLabel ?? '—';
  const ticker = isUsdtLikeAsset(options?.assetLabel)
    ? 'USDT'
    : (options?.assetLabel?.trim() || undefined);

  return formatDecimal(value, {
    asset: ticker,
    signed: options?.signed,
    emptyLabel,
    decimals: getDisplayDecimals(ticker),
    trimTrailingZeros: true,
  });
};

export const resolveAssetRemainder = (params: {
  assetLabel?: string | null;
  assetBalanceAmount?: string | null;
  balanceAmount: string | number | null | undefined;
}): { amount: string | null; ticker: string | null } => {
  if (params.assetBalanceAmount != null && params.assetBalanceAmount !== '') {
    const ticker = isUsdtLikeAsset(params.assetLabel) ? 'USDT' : (params.assetLabel?.trim() || null);
    return { amount: params.assetBalanceAmount, ticker };
  }

  if (isUsdtLikeAsset(params.assetLabel)) {
    return {
      amount: params.balanceAmount == null ? null : String(params.balanceAmount),
      ticker: 'USDT',
    };
  }

  return { amount: null, ticker: params.assetLabel?.trim() || null };
};
